import { CheckCircle, ContentCopy } from "@mui/icons-material";
import { Box, Button, Card, CardContent, IconButton, ThemeProvider, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import logo from '../../images/logo.png';
import { useUtils } from "../../utils/utilFunctions";
import { lightTheme } from "../complaint-form/ComplaintForm";
import './ComplaintEnd.scss';

const ComplaintEnd: FC = () => {
	const { id, protocol } = useParams<{ id: string, protocol: string }>();
	const navigate = useNavigate();
	const { handleCopy } = useUtils();

	const handleNewComplaint = () => {
		navigate(`/canal-de-denuncias/${id}`);
	};

	const handleTrackComplaint = () => {
		navigate(`/canal-de-denuncias/${id}/acompanhamento/${protocol}`);
	};

	const handleClickGoHome = () => {
		navigate(`/canal-de-denuncias/${id}/acompanhamento/`);
	};

	return (
		<ThemeProvider theme={lightTheme}>
			<div className="complaint-end-page">
				<Box className="form-container">
					<img src={logo} alt="Logo da empresa" className="form-logo" onClick={handleClickGoHome}/>
					<header className="form-header-end">
						<CheckCircle color="success" sx={{ fontSize: 40 }} />
						<Typography variant="h5" component="h1">Denúncia registrada com sucesso</Typography>
					</header>
					<main className="form-body-end">
						<Typography variant="body1" align="center" sx={{ mb: 2 }}>
							Sua denúncia foi recebida e está sob análise.
						</Typography>
						<Card variant="outlined" className="protocol-card">
							<CardContent>
								<Typography variant="overline" display="block">Protocolo</Typography>
								<Box className="protocol-box">
									<Typography variant="h6" component="span">{protocol}</Typography>
									<IconButton onClick={() => handleCopy(protocol || '')} size="small" aria-label="Copiar protocolo">
										<ContentCopy fontSize="small" />
									</IconButton>
								</Box>
								<Typography variant="caption">
									 <b>Importante:</b> Guarde este protocolo, sem ele não é possível acompanhar sua denúncia. 
								</Typography>
							</CardContent>
						</Card>
						<Card variant="outlined" className="info-card">
							<CardContent>
								<Typography variant="body2">
									Você poderá acompanhar o andamento informando o protocolo no portal.
								</Typography>
							</CardContent>
						</Card>
						<Box className="action-buttons">
							<Button variant="contained" color="primary" onClick={handleTrackComplaint}>
								Acompanhar denúncia
							</Button>
							<Button variant="outlined" color="primary" onClick={handleNewComplaint}>
								Fazer nova denúncia
							</Button>
						</Box>
					</main>
				</Box>
			</div>
		</ThemeProvider>
	);
}

export default ComplaintEnd;